import type { Option } from '@zen/DesignSystem/types';

import { TemperatureUnit } from './types';

export const temperatureUnitOptions: Option<TemperatureUnit>[] = [
  { label: '°C', value: TemperatureUnit.CELSIUS },
  { label: '°F', value: TemperatureUnit.FAHRENHEIT }
];
